var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86597 8.78352C3.86597 8.28867 4.03092 7.95878 4.36081 7.62888C5.02061 6.96908 6.0103 6.96908 6.67009 7.62888L11.9484 12.9072L17.0618 7.62888C17.7216 6.96908 18.7113 6.96908 19.3711 7.62888C20.0309 8.28867 20.0309 9.27836 19.3711 9.93816L12.9381 16.3711C12.6082 16.701 12.2783 16.866 11.7835 16.866C11.2886 16.866 10.9588 16.701 10.6289 16.3711L4.36081 9.93816C4.03092 9.60826 3.86597 9.27836 3.86597 8.78352Z",
    fill: "#12284A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.aa752cea038d48500c45fafd923c5b1d.svg";
export { ForwardRef as ReactComponent };